import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import '../styles/PackageCards.css';

const FALLBACK_PACKAGES = [
  { id: 'basic', title: 'BASIC PACKAGE', price: '2199', color: 'blue', popular: false },
  { id: 'standard', title: 'STANDARD PACKAGE', price: '2399', color: 'red', popular: true },
  { id: 'premium', title: 'PREMIUM PACKAGE', price: '2599', color: 'blue', popular: false }
];

const PackageCards = () => {
  const [expandedSections, setExpandedSections] = useState({});
  const [packages, setPackages] = useState(FALLBACK_PACKAGES);
  const [packageContent, setPackageContent] = useState({});
  const [packageSections, setPackageSections] = useState([
    'Design',
    'Project Management',
    'Structure',
    'Bathroom & Plumbing',
    'Flooring',
    'What\'s Not Included'
  ]);

  const API_BASE_URL = 'https://eks-projectmanager.eksconstruction.in/api';

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/get_packages.php`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const result = await response.json();

        if (result.success && Array.isArray(result.packages) && result.packages.length > 0) {
          const mappedPackages = result.packages.map(p => ({
            id: p.package_key,
            title: p.title,
            price: p.price,
            color: p.color,
            popular: !!p.popular
          }));

          const content = {};
          result.packages.forEach(p => {
            content[p.package_key] = p.sections || {};
          });

          const firstSections = result.packages[0].sections
            ? Object.keys(result.packages[0].sections)
            : null;

          setPackages(mappedPackages);
          setPackageContent(content);
          if (firstSections && firstSections.length > 0) {
            setPackageSections(firstSections);
          }
        }
      } catch (error) {
        // Keep fallback packages/content on failure so the page still renders
        console.error('Failed to fetch packages:', error);
      }
    };

    fetchPackages();
  }, []);

  const toggleSection = (packageId, section) => {
    const key = `${packageId}-${section}`;
    setExpandedSections(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const getSectionContent = (packageId, section) => {
    const content = packageContent[packageId]?.[section];
    if (content) {
      return (
        <ul className="feature-list">
          {content.items.map((item, index) => (
            <li key={index} className="feature-list-item">
              <span className="feature-check">✓</span>
              {item}
            </li>
          ))}
        </ul>
      );
    }
    return <p className="feature-placeholder">Detailed specifications for {section.toLowerCase()} will be provided upon request.</p>;
  };

  return (
    <section className="packages-section">
      <div className="packages-container">
        <motion.div
          className="packages-grid"
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.8 }}
        >
          {packages.map((pkg, index) => (
            <motion.div
              key={pkg.id}
              className={`package-card ${pkg.color} ${pkg.popular ? 'popular' : ''}`}
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.1 * index, duration: 0.6 }}
              whileHover={{ y: -5 }}
            >
              {pkg.popular && <div className="popular-badge">MOST POPULAR</div>}

              <div className="package-header">
                <h3>{pkg.title}</h3>
                <div className="package-price">
                  <span className="currency">₹</span>
                  <span className="amount">{pkg.price}</span>
                  <span className="unit">per sqft</span>
                </div>
              </div>

              <div className="package-features">
                {packageSections.map((section) => (
                  <div key={section} className="feature-item">
                    <button
                      className="feature-header"
                      onClick={() => toggleSection(pkg.id, section)}
                    >
                      <span>{section}</span>
                      <span className="toggle-icon">
                        {expandedSections[`${pkg.id}-${section}`] ? '−' : '+'}
                      </span>
                    </button>
                    {expandedSections[`${pkg.id}-${section}`] && (
                      <motion.div
                        className="feature-content"
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        {getSectionContent(pkg.id, section)}
                      </motion.div>
                    )}
                  </div>
                ))}
              </div>
              <a
                href="https://wa.me/8148353564"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="get-specification-btn">
                  For Detailed specifications
                </button>
              </a>


            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default PackageCards;
